import * as d3 from 'd3'

export default {
  methods: {
    call_Link(selection) {
      selection
      .on('click', () => { 
        let dataSource = {}

        // Mapping the jsonLink(value) to JsonProps in A/G 
        let request_ = this.getRequestColumnProps('comment', dataSource, this.ColumnProps)
        if(!request_) return

        // set for comment-props
        if(!request_.action.commentProps) {
          request_.action.commentProps.title = `TEXT_EDITOR_TEST`
          request_.action.commentProps.refCode = `TEXT_EDITOR_TEST` 
          // request_.action.commentProps.authority.write.permission = 'MANAGER'
          request_.action.commentProps.authority.write.levelno = 2
          request_.action.commentProps.authority.write.granted = '<='
          
          // PERMISSION_LEVEL: {
          //   SYS_ADMIN  : 0,
          //   SVC_ADMIN  : 1,
          //   MANAGER    : 2,
          //   APPROVER   : 3,
          //   REVIEWER   : 4,
          //   DESIGNER   : 5,
          //   LEAD       : 6,
          //   COORDINATOR: 7,
          //   ENGINEER   : 8,
          // },
          /**
           * commentProps **
           * 
           * {
           *    refCode: String,          // the code that comment(s) belong to...
           *    authority: {
           *      write: {
           *        permission: String,   // the permission code that allow to write the comment
           *        levelno: Number,      // the permission level of the permission
           *        granted: String,      // the inequality sign code for permission level, < | > | <= | >= | =
           *      }
           *    }
           * }
           */
        }
        


        // set for filterString 
        let filterString_ = ''
        

        // if A/G filterString is exist, set request_.iFilters.filterString + filterString_
        if(request_.iFilters.filterString) {
          request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
        } else {
          request_.iFilters.filterString = filterString_||''
        }

        // combine filterString and inputFilter &&& emit request-action
        request_ = {...request_,
          filters : {
            ...this.FilterValues,
            ...request_.filters,
          },
          iFilters: { 
            filterString : request_.iFilters.filterString||'',
            inputFilter : request_.iFilters.inputFilter,},
        }
        this.$emit('request-action', request_)
      })
    }, 
  }
}